import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import commonService from "services/commonService";
import { toast } from "react-toastify";
function HCPPage() {
  const productId = 110;
  const commonServiceObj = new commonService();
  const [link, getLink] = useState([]);
  useEffect(() => {
    getProductLinks()
  }, []);
  const getProductLinks = () => {
    commonServiceObj.getLegacyLinks(productId).then(data => {
      let links = data[0]?.links;
      getLink(links[0]?.link)

    }).catch(err => {
      toast.error('Not able to fetch data properly');
    }
    )
  }
  return (
    <div className="form-wrap">
      <div className="row pl-4">
        <div className="col-lg-12">
          <h3 className="mt-1">Hitachi Content Platform(HCP)</h3>
        </div>
      </div>
      <div className="row pl-4">
        <div className="col-lg-12">
          <p>HCP is Amazon S3-compatible
            object storage and is compatible with 3rd party clients that
            utilize the Amazon S3 API. For information regarding which S3
            APIs are implemented and supported please refer to the product documentation
            <a className="branding-red" href={link} target="_blank"> here</a> .
          </p>
        </div>
      </div>

      <div className="row pl-4">
        <div className="col-lg-12">
          ISV applications that have been previously validated with Hitachi storage can be found in the Solutions tab or by following the links below:

          <p key={1} className='mt-2 p-1'><a className="branding-red" href="/products/data-protection"><FontAwesomeIcon size="lg" icon={["far", "file-alt"]} /> Data Protection</a></p>
          <p key={2} className='p-1'><a className="branding-red" href="/products/data-management-ai-lakehouse-other-isv"><FontAwesomeIcon size="lg" icon={["far", "file-alt"]} /> Data Management ISVs: AI, Lakehouse, Other</a></p>

        </div>
      </div>

    </div>
  )
}

export default HCPPage